// extracted by mini-css-extract-plugin
module.exports = {"footer":"SccsmFooter_footer__3-Id7","button":"SccsmFooter_button__35uAA","button-ltr":"SccsmFooter_button-ltr__84GIl"};